module.exports = __webpack_public_path__ + "img/mobile-mapping-planning.d57acd4c.jpg";